module.exports = __webpack_public_path__ + "static/images/event/marker_red_sm.png";